import { Nullable } from './general';

export enum EventActionValues {
  Click = 'click',
  Show = 'show',
}

export enum EventCategoryValues {
  Registration = 'registration',
  Login = 'login',
  AccountLinking = 'account-linking',
  Invitation = 'invitation',
}

export enum EventContextValues {
  Cancel = 'cancel',
  ReadMore = 'read-more',
}

export enum EventLabelValues {
  PersonalInfo = 'personal-info',
  PersonalInfoContinue = 'personal-info-continue',
  PersonalInfoCancel = 'personal-info-cancel',
  PersonalInfoReadMore = 'personal-info-read-more',

  ConfirmEmail = 'confirm-email',
  ConfirmEmailContinue = 'confirm-email-continue',
  ConfirmEmailCancel = 'confirm-email-cancel',
  ConfirmEmailReadMore = 'confirm-email-read-more',

  ContinueAsKnownUser = 'continue-as-known-user',
  ContinueAsOtherUser = 'continue-as-other-user',

  ProvideCredentials = 'provide-credentials',
  ProvideCredentialsCancel = 'provide-credentials-cancel',
  ProvideCredentialsReadMore = 'provide-credentials-read-more',

  SpotifyAccountLinks = 'spotify-account-links',
  SpotifyAccountLinksToOverview = 'spotify-account-links-to-overview',
  SpotifyNoSubscriptionToAboshop = 'spotify-no-subscription-to-aboshop',

  // Invitation labels
  InvitationAccept = 'invitation-accept',
  InvitationAcceptContinue = 'invitation-accept-continue',
  InvitationAcceptOtherUser = 'invitation-accept-otheruser',
  InvitationCompleted = 'invitation-completed',
  InvitationCompletedContinue = 'invitation-completed-continue',
  // Invitation error labels
  InvitationErrorGeneric = 'invitation-unhandled-error',
  InvitationErrorInviteExpired = 'invitation-expired',
  InvitationErrorAlreadyHasRole = 'invitation-alreadymember',
  InvitationErrorAlreadyHasRoleOtherUser = 'invitation-alreadymember-otheruser',
}

export interface TrackingProperties {
  eventaction: EventActionValues;
  eventcategory: Nullable<EventCategoryValues>;
  eventlabel: Nullable<EventLabelValues>;
  pagetitle?: string;
  pagetype?: string;
  pageurl?: string;
  itemdescription?: string;
  servertimestamp?: string;
  viewsequence?: number;
  eventid?: string;
  ga_event_name?: string;
}

export enum VIEWS {
  PERSONAL_INFO = EventLabelValues.PersonalInfo,
  CONFIRM_EMAIL = EventLabelValues.ConfirmEmail,
  ACCOUNT_CONSENT = EventLabelValues.ProvideCredentials,
}
